/**
 * Created by Ning Jiang on 2023-09-07.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = DevilsCrossRoad.model.data;
        return !data.mode.includes(GameMode.FREESPIN) && data.nextMode.includes(GameMode.FREESPIN);
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        DevilsCrossRoad.scatters.scatters.forEach(scatter => {
            // TODO: play different animation according to scatters.counter;
            tl.add(scatter.playWinFS(), 0);
        });
        tl.add(() => {
            const name = DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN ?
                DevilsCrossRoadSound.SCATTERS_WIN_SFS :
                DevilsCrossRoadSound.SCATTERS_WIN_FS;
            DevilsCrossRoadSound.soundPlayer.playTrack({name : name});
        }, 0);
        if(tl.totalDuration() > 0) {
            return Promise.resolve(tl);
        }

        return Promise.resolve();
    }
}